<template>
  <div class="btn-group" role="group">
    <button
      v-for="value of computedValues"
      type="button"
      class="btn"
      :disabled="disabled"
      :class="[disabled ? 'btn-disabled' : '', modelValueInner === value.value ? activeClass : inactiveClass]"
      @click="modelValueInner = value.value"
      v-text="value.label"
    />
  </div>
</template>

<script>
export default {
  name: 'BootstrapButtonGroup',
  props: {
    values: {
      // An array of { label: 'Label', value: '0' } objects
      type: Array,
      required: true,
    },
    activeClass: {
      type: String,
      required: false,
      default: 'btn-primary',
    },
    inactiveClass: {
      type: String,
      required: false,
      default: 'btn-light',
    },
    modelValue: {
      require: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    this.modelValueInner = this.modelValue;
  },
  data() {
    return {
      modelValueInner: this.modelValue,
    };
  },
  computed: {
    computedValues() {
      const computedValues = [];

      for (const value of this.values) {
        if (typeof(value) === 'object') {
          computedValues.push({
            value: value.value,
            label: value.label,
          });
        } else {
          // Just use the raw value
          computedValues.push({
            value: value,
            label: value,
          });
        }
      }

      return computedValues;
    },
  },
  emits: ['update:modelValue'],
  watch: {
    modelValue() {
      if (this.modelValue === this.modelValueInner) {
        return;
      }

      this.modelValueInner = this.modelValue;
    },
    modelValueInner() {
      if (this.modelValueInner === this.modelValue) {
        return;
      }

      console.log('modelValueInnerChanged', this.modelValueInner);

      if (this.disabled) {
        return; // Ignore
      }

      this.$emit('update:modelValue', this.modelValueInner);
    }
  }

}
</script>
